import { isBLMitraAndroid, getMitraAppVersion } from '~/utils/platform';

async function retrieveAppUpdateVersionConfig(configName, state, dispatch, commit) {
  try {
    if (isBLMitraAndroid()) {
      const storageKey = `${configName}_update_apps_prompt_config`;
      let minAndroidVersion = '0';
      const storedConfig = window.localStorage.getItem(storageKey);
      const ttl = 15 * 60 * 1000; // 15 minute
      if (storedConfig) {
        const parsedConfig = JSON.parse(storedConfig);
        if (Date.now() < parsedConfig?.expiry) {
          minAndroidVersion = parsedConfig?.min_android_version;
        } else {
          window.localStorage.removeItem(storageKey);
        }
      }
      if (minAndroidVersion === '0') {
        let appUpdateVersionConfig = state.appUpdateVersionConfigResponse;
        if (!appUpdateVersionConfig?.[configName]) {
          const result = await dispatch('fetchNeoConfigs', ['mitra-apps-update-version-config']);
          commit('setAppUpdateVersionConfigResponse', result?.[0]?.data);
          appUpdateVersionConfig = result?.[0]?.data;
        }
        minAndroidVersion = appUpdateVersionConfig?.[configName]?.min_android_version || '0';
        if (minAndroidVersion === '0') return;
        window.localStorage.setItem(
          storageKey,
          JSON.stringify({
            min_android_version: minAndroidVersion,
            expiry: Date.now() + ttl,
          })
        );
      }
      commit('setAppUpdateVersionConfig', {
        [configName]: { min_android_version: minAndroidVersion },
      });
    }
  } catch {}
}

function getUpdateAppsPrompt(configName, state): boolean {
  const deviceVersion = getMitraAppVersion() || 0;
  const showUpdateAppsPrompt =
    deviceVersion < (Number.parseInt(state.appUpdateVersionConfig?.[configName]?.min_android_version, 10) || 0);
  return showUpdateAppsPrompt;
}

const initialState = {
  appUpdateVersionConfigResponse: {},
  appUpdateVersionConfig: {},
};

const getters = {
  mitraReferralUpdateAppsPrompt(state) {
    return getUpdateAppsPrompt('mitra_referral', state);
  },
  mitraSubscriptionUpdateAppsPrompt(state) {
    return getUpdateAppsPrompt('mitra_subscription', state);
  },
};

const mutations = {
  setAppUpdateVersionConfigResponse(state, config) {
    state.appUpdateVersionConfigResponse = config;
  },
  setAppUpdateVersionConfig(state, config) {
    state.appUpdateVersionConfig = { ...state.appUpdateVersionConfig, ...config };
  },
};

const actions = {
  retrieveMitraReferralAppUpdateVersionConfig({ state, dispatch, commit }) {
    retrieveAppUpdateVersionConfig('mitra_referral', state, dispatch, commit);
  },
  retrieveMitraSubscriptionAppUpdateVersionConfig({ state, dispatch, commit }) {
    retrieveAppUpdateVersionConfig('mitra_subscription', state, dispatch, commit);
  },
};

export default {
  state: () => ({
    ...initialState,
  }),
  getters,
  mutations,
  actions,
};
